import React from "react";
import { Anchor, Typography } from "antd";
// import styles from "./ConceptRightSidebar.module.scss";

const { Title } = Typography;

const ConceptRightSidebar = ({ activeSection }) => {
  const mainSection = activeSection.includes(":")
    ? activeSection.split(":")[0]
    : activeSection;

  const sectionLinks = {
    overview: [
      { href: "#overview:description", title: "Description" },
      { href: "#overview:statistics", title: "Bibliometrics" },
      { href: "#overview:sub-concepts", title: "Sub-concepts" },
      { href: "#overview:related-concepts", title: "Related Concepts" },
    ],
    research: [
      { href: "#research:publications", title: "Publications" },
      { href: "#research:academics", title: "Academics" },
    ],
    resources: [
      { href: "#resources:intro", title: "Introductory" },
      { href: "#resources:edu", title: "Educational" },
      { href: "#resources:multimedia", title: "Multimedia" },
    ],
  };

  const items = sectionLinks[mainSection] || [];

  return (
    <div 
    // className={styles.rightSidebar}
    >
      <Title level={4}>On this page</Title>
      <Anchor
        affix={false}
        offsetTop={24}
        items={items.map((link) => ({
          key: link.href,
          title: link.title,
          href: link.href,
        }))}
        // className={styles.anchor}
      />
    </div>
  );
};

export default ConceptRightSidebar;
